"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.string.ends-with.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.fill.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _max2 = _interopRequireDefault(require("lodash/max"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _uploadcareWidgetTabEffects = _interopRequireDefault(require("uploadcare-widget-tab-effects"));

var _uploadcareWidget = _interopRequireDefault(require("uploadcare-widget"));

var _uploadClient = require("@uploadcare/upload-client");

var _analytics = require("./analytics");

var _validators = require("./validators");

var _url = require("./url");

var _constants = require("./constants");

var _copy = require("./copy");

var _thirdPartyTabStyles = _interopRequireDefault(require("./thirdPartyTabStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// NOTE: for styles, import '@zola/zola-ui/src/styles/uploadcareWidget.less';
var EDIT_IMAGE_DISABLED_CLASS = 'zola-image-edit-disabled';
var ERROR_STATE_CLASS = 'zola-state-error';
var ONLY_EDIT_IMAGE_CLASS = 'zola-only-edit-image';
var PROGRESS_STATE_CLASS = 'zola-state-progress';
var REMOVE_IMAGE_DISABLED_CLASS = 'zola-image-remove-disabled';
var SUBMIT_AFTER_UPLOAD_CLASS = 'zola-submit-images-after-upload';

var getPreviewTab = function getPreviewTab(showEffects) {
  if (showEffects) {
    // Apply effect tabs to enable photo editing in the modal
    _uploadcareWidget.default.registerTab('preview', _uploadcareWidgetTabEffects.default);

    return _uploadcareWidgetTabEffects.default;
  }

  var unwrappedUC;

  _uploadcareWidget.default.plugin(function (internalUC) {
    unwrappedUC = internalUC;
  });

  var _unwrappedUC$widget$t = unwrappedUC.widget.tabs,
      PreviewTab = _unwrappedUC$widget$t.PreviewTab,
      PreviewTabMultiple = _unwrappedUC$widget$t.PreviewTabMultiple; // The following function is based on https://github.com/uploadcare/uploadcare-widget/blob/1b33ac45986bffeb311bdb1293170b3925932aa1/src/widget/dialog.js#L215

  return function (tabPanel, tabButton, dialogApi, settings, name) {
    if (!settings.previewStep && dialogApi.fileColl.length() === 0) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return function () {};
    }

    var TabClass = settings.multiple ? PreviewTabMultiple : PreviewTab;
    return new TabClass(tabPanel, tabButton, dialogApi, settings, name);
  };
}; // Listens for changes to Uploadcare's file collection and adds an error or progress class
// to the dialog element as needed (depending on the files' status).


var handleWidgetState = function handleWidgetState(dialogElement, fileColl, maxFileCount, dynamicPreviewTitle, submitAfterUpload, submitAfterUploadNotifyError) {
  // eslint-disable-next-line no-underscore-dangle
  var widgetFiles = fileColl.__items;

  var updateWidgetState = function updateWidgetState() {
    var anyFilesInProgress = widgetFiles.some(function (file) {
      return file.state() === 'pending';
    });
    var anyFilesFailed = widgetFiles.some(function (file) {
      return file.state() === 'rejected';
    });
    var anyFilesResolved = widgetFiles.some(function (file) {
      return file.state() === 'resolved';
    });

    if (anyFilesInProgress) {
      dialogElement.addClass(PROGRESS_STATE_CLASS);
      dialogElement.removeClass(ERROR_STATE_CLASS);
    } else if (anyFilesFailed) {
      dialogElement.removeClass(PROGRESS_STATE_CLASS);
      dialogElement.addClass(ERROR_STATE_CLASS);
    } else {
      dialogElement.removeClass(PROGRESS_STATE_CLASS);
      dialogElement.removeClass(ERROR_STATE_CLASS);
    } // Widget does not rerender if you update the locale object (it usues jQuery under the hood). To get the preview title to be dynamic we have to override with JS when widget state changes
    // Behavior is controlled by dynamicPreviewTitle prop passed into openUploadcareModal


    if (dynamicPreviewTitle) {
      var previewTitle = dialogElement.find('#preview__title')[0];

      if (previewTitle) {
        previewTitle.textContent = "Review and edit ".concat(widgetFiles.length, " ").concat(widgetFiles.length === 1 ? 'photo' : 'photos');
      }
    }

    if (submitAfterUpload) {
      // Show above the upload list how many files are uploading
      var _previewTitle = dialogElement.find('#preview__title')[0];

      if (_previewTitle) {
        if (widgetFiles.length === 0) {
          _previewTitle.textContent = 'No photos uploaded. Select a tab to upload';
        } else {
          _previewTitle.textContent = "Uploading ".concat(widgetFiles.length, " ").concat(widgetFiles.length === 1 ? 'photo' : 'photos', " ...");
        }
      } // If no files are in progress Uploadcare is finished. This triggers the submit


      if (anyFilesInProgress === false && anyFilesResolved) {
        var addSubmitBtn = dialogElement.find('button.uploadcare--preview__done')[0];

        if (addSubmitBtn) {
          addSubmitBtn.click();
        }
      }
    }
  }; // User added a new file


  fileColl.onAdd.add(function (file) {
    // Immediately cancel the upload if over maxFileCount (to save time and bandwidth)
    if (maxFileCount && widgetFiles.length > maxFileCount) file.cancel();

    if (submitAfterUpload && file.state() === 'rejected') {
      // When immediately sumbitting, skipping the preview, remove any rejected files
      fileColl.remove(file);
      if (submitAfterUploadNotifyError) submitAfterUploadNotifyError();
    } // When an upload starts, update the widget state


    updateWidgetState(); // When an upload completes (success or failure), update the widget state

    file.always(updateWidgetState);
  }); // User clicked file's trash icon

  fileColl.onRemove.add(function (file) {
    // When a pending file is removed from the list, force the upload to cancel (to save time and bandwidth)
    if (file.state() === 'pending') file.cancel(); // When a file is removed, update the widget state

    file.always(updateWidgetState);
  });
};

var formatImagesWithPaddedBorder = function formatImagesWithPaddedBorder(originalUrl, fileInfo) {
  var _fileInfo$crop, _fileInfo$crop2;

  if (fileInfo && fileInfo.crop && ((fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$crop = fileInfo.crop) === null || _fileInfo$crop === void 0 ? void 0 : _fileInfo$crop.left) > 0 || (fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$crop2 = fileInfo.crop) === null || _fileInfo$crop2 === void 0 ? void 0 : _fileInfo$crop2.top) > 0)) {
    var _fileInfo$originalIma, _fileInfo$originalIma2, _fileInfo$originalUrl;

    var higherValue = (0, _max2.default)([fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$originalIma = fileInfo.originalImageInfo) === null || _fileInfo$originalIma === void 0 ? void 0 : _fileInfo$originalIma.width, fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$originalIma2 = fileInfo.originalImageInfo) === null || _fileInfo$originalIma2 === void 0 ? void 0 : _fileInfo$originalIma2.height]);
    return "".concat(fileInfo.originalUrl).concat((_fileInfo$originalUrl = fileInfo.originalUrl) !== null && _fileInfo$originalUrl !== void 0 && _fileInfo$originalUrl.endsWith('/') ? '' : '/', "-/setfill/ffffff/-/stretch/fill/-/crop/").concat(higherValue, "x").concat(higherValue, "/center/");
  }

  return originalUrl;
};

var openUploadcareModal = function openUploadcareModal(_ref) {
  var addSquareToUploads = _ref.addSquareToUploads,
      analyticsLocation = _ref.analyticsLocation,
      analyticsProduct = _ref.analyticsProduct,
      _ref$closeViaOverlay = _ref.closeViaOverlay,
      closeViaOverlay = _ref$closeViaOverlay === void 0 ? true : _ref$closeViaOverlay,
      cropRatio = _ref.cropRatio,
      _ref$dynamicPreviewTi = _ref.dynamicPreviewTitle,
      dynamicPreviewTitle = _ref$dynamicPreviewTi === void 0 ? false : _ref$dynamicPreviewTi,
      _ref$editImageDisable = _ref.editImageDisabled,
      editImageDisabled = _ref$editImageDisable === void 0 ? false : _ref$editImageDisable,
      editImageUrl = _ref.editImageUrl,
      effects = _ref.effects,
      imageShrink = _ref.imageShrink,
      _ref$inputAcceptTypes = _ref.inputAcceptTypes,
      inputAcceptTypes = _ref$inputAcceptTypes === void 0 ? _constants.DEFAULT_FILE_TYPES : _ref$inputAcceptTypes,
      _ref$maxFileCount = _ref.maxFileCount,
      maxFileCount = _ref$maxFileCount === void 0 ? 0 : _ref$maxFileCount,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? _constants.DEFAULT_MAX_FILE_SIZE_MB : _ref$maxSize,
      minDimension = _ref.minDimension,
      _ref$minFileCount = _ref.minFileCount,
      minFileCount = _ref$minFileCount === void 0 ? 1 : _ref$minFileCount,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth,
      multipartMinSize = _ref.multipartMinSize,
      onAddPhotos = _ref.onAddPhotos,
      onUploadcareFileReady = _ref.onUploadcareFileReady,
      _ref$previewStep = _ref.previewStep,
      previewStep = _ref$previewStep === void 0 ? true : _ref$previewStep,
      _ref$removeImageDisab = _ref.removeImageDisabled,
      removeImageDisabled = _ref$removeImageDisab === void 0 ? false : _ref$removeImageDisab,
      _ref$showEffects = _ref.showEffects,
      showEffects = _ref$showEffects === void 0 ? true : _ref$showEffects,
      styleId = _ref.styleId,
      _ref$submitAfterUploa = _ref.submitAfterUpload,
      submitAfterUpload = _ref$submitAfterUploa === void 0 ? false : _ref$submitAfterUploa,
      submitAfterUploadNotifyError = _ref.submitAfterUploadNotifyError,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? _constants.DEFAULT_TABS : _ref$tabs,
      _ref$defaultTab = _ref.defaultTab,
      defaultTab = _ref$defaultTab === void 0 ? _constants.UploadCareTabTypes.FILE : _ref$defaultTab,
      _ref$useSquareImg = _ref.useSquareImg,
      useSquareImg = _ref$useSquareImg === void 0 ? false : _ref$useSquareImg,
      value = _ref.value,
      _ref$copyTemplate = _ref.copyTemplate,
      copyTemplate = _ref$copyTemplate === void 0 ? _copy.DEFAULT_COPY : _ref$copyTemplate,
      _ref$additionalUpload = _ref.additionalUploadedFilesTrackingProperties,
      additionalUploadedFilesTrackingProperties = _ref$additionalUpload === void 0 ? {} : _ref$additionalUpload,
      _ref$additionalUpload2 = _ref.additionalUploadEventTrackingProperties,
      additionalUploadEventTrackingProperties = _ref$additionalUpload2 === void 0 ? {} : _ref$additionalUpload2,
      _ref$customTabs = _ref.customTabs,
      customTabs = _ref$customTabs === void 0 ? [] : _ref$customTabs;
  var $ = _uploadcareWidget.default.jQuery;
  var isMultiple = minFileCount > 1 || maxFileCount > 1;
  var customTabTitleCopy = {};

  var fullTabList = _toConsumableArray(tabs);

  var _getUploadAnalytics = (0, _analytics.getUploadAnalytics)(analyticsProduct, analyticsLocation, additionalUploadedFilesTrackingProperties, additionalUploadEventTrackingProperties),
      startAnalytics = _getUploadAnalytics.startAnalytics,
      stopAnalytics = _getUploadAnalytics.stopAnalytics;

  var handleFileSelect = function handleFileSelect(file) {
    // If the cached image was deleted, ignore the change.
    if (!file) return;
    if (onAddPhotos) onAddPhotos(); // eslint-disable-next-line @typescript-eslint/no-floating-promises

    file.done(function (completedFile) {
      // Don't invoke callback if nothing changed
      var newUrl = (0, _url.stripUploadcareUrlPatches)(completedFile.cdnUrl);
      var valueisIdentical = value && newUrl === value[0];
      if (valueisIdentical) return;
      onUploadcareFileReady((0, _url.patchUploadcareFileUrls)(completedFile));
    });
  };

  var handleFileGroupSelect = function handleFileGroupSelect(fileGroup) {
    // If all cached images were deleted, ignore the change.
    if (!fileGroup) return;
    if (onAddPhotos) onAddPhotos();
    var filePromises = fileGroup.files().map(function (file) {
      return new Promise(function (resolve) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        file.done(function (completedFile) {
          return resolve(completedFile);
        });
      });
    });
    Promise.all([fileGroup.promise()].concat(_toConsumableArray(filePromises))).then(function (_ref2) {
      var _ref3 = _toArray(_ref2),
          completedGroup = _ref3[0],
          completedFiles = _ref3.slice(1);

      var newUrls = completedFiles.map(function (f) {
        return (0, _url.stripUploadcareUrlPatches)(f.cdnUrl);
      });
      var valuesAreIdentical = value && newUrls.every(function (newUrl, i) {
        return newUrl === value[i];
      }); // Only invoke callback if images or image order change.

      if (valuesAreIdentical) return;
      var patchedFiles = completedFiles.map(_url.patchUploadcareFileUrls);

      if (addSquareToUploads) {
        patchedFiles = patchedFiles.map(function (file) {
          var updatedFile = _objectSpread({}, file);

          if (file && file.originalUrl) updatedFile.originalUrl = formatImagesWithPaddedBorder(file.originalUrl, file);
          if (file && file.cdnUrl) updatedFile.cdnUrl = formatImagesWithPaddedBorder(file.cdnUrl, file);
          return updatedFile;
        });
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      onUploadcareFileReady(completedGroup.uuid, patchedFiles);
    }).catch(function () {
      return new Error('Problem uploading uploadcare files');
    });
  }; // Register our "custom" preview tab, which is either the effects tab, the single file preview or multi file preview


  _uploadcareWidget.default.registerTab('preview', getPreviewTab(showEffects)); // Process any additional custom tabs


  customTabs.forEach(function (_ref4) {
    var key = _ref4.key,
        sidebarTitle = _ref4.sidebarTitle,
        sidebarIcon = _ref4.sidebarIcon,
        constructor = _ref4.constructor;
    // Add the tab's title to the copy
    customTabTitleCopy[key] = sidebarTitle; // If sidebarIcon is defined, we need to make sure it's in the document for it to appear in the sidebar

    if (sidebarIcon) {
      var iconId = "uploadcare--icon-".concat(key);

      if (!document.getElementById(iconId)) {
        var svgContent = sidebarIcon.svgContent,
            viewBox = sidebarIcon.viewBox,
            _sidebarIcon$fill = sidebarIcon.fill,
            fill = _sidebarIcon$fill === void 0 ? 'currentColor' : _sidebarIcon$fill;
        $(document.body).prepend($("\n          <svg width=\"0\" height=\"0\" style=\"position:absolute\" xmlns=\"http://www.w3.org/2000/svg\">\n            <symbol id=\"".concat(iconId, "\" viewBox=\"").concat(viewBox, "\" fill=\"").concat(fill, "\">\n              ").concat(svgContent, "\n            </symbol>\n          </svg>\n        ")));
      }
    } // Add the tab's key to the list of tabs (if not already included)


    if (!fullTabList.includes(key)) {
      fullTabList.push(key);
    } // Register the tab's constructor


    _uploadcareWidget.default.registerTab(key, constructor);
  });
  var validators = [(0, _validators.validateMinDimensions)(minWidth, minHeight, minDimension), (0, _validators.validateMaxFileSize)(maxSize), (0, _validators.validateFileType)(inputAcceptTypes)]; // Full list of settings for Uploadcare can be found in their API: https://uploadcare.com/docs/uploads/file-uploader-options/

  var settings = {
    crop: cropRatio,
    effects: effects || "".concat(cropRatio ? 'crop,' : '', "mirror,enhance,sharp,blur,grayscale"),
    imageShrink: imageShrink,
    imagesOnly: true,
    inputAcceptTypes: inputAcceptTypes.join(','),
    multipartMinSize: multipartMinSize,
    multiple: isMultiple,
    multipleMax: maxFileCount,
    multipleMin: minFileCount,
    preloader: null,
    previewStep: previewStep,
    previewUrlCallback: useSquareImg ? formatImagesWithPaddedBorder : undefined,
    publicKey: _constants.PUBLIC_KEY,
    tabs: fullTabList,
    validators: validators
  }; // Apply our custom styles to 3rd party tabs (e.g. Facebook, Dropbox)

  _uploadcareWidget.default.tabsCss.addStyle(_thirdPartyTabStyles.default); // Make sure the dialog copy contains the current widget's settings


  _uploadcareWidget.default.plugin(function (internal) {
    // Add custom tab titles to the copy
    var fullCopyTemplate = Object.keys(customTabTitleCopy).length ? (0, _merge2.default)((0, _cloneDeep2.default)(copyTemplate), {
      dialog: {
        tabs: {
          names: customTabTitleCopy
        }
      }
    }) : copyTemplate;
    var filledOutCopy = (0, _copy.getWidgetCopy)({
      values: {
        inputAcceptTypes: inputAcceptTypes,
        maxFileCount: maxFileCount,
        maxSize: maxSize,
        minDimension: minDimension,
        minHeight: minHeight,
        minWidth: minWidth
      },
      isEditOnly: !!editImageUrl,
      copyTemplate: fullCopyTemplate
    }); // eslint-disable-next-line no-param-reassign

    internal.locale.translations.en = (0, _merge2.default)(internal.locale.translations.en, filledOutCopy);
    internal.locale.rebuild();
  }); // Determine which tab to select by default


  var tabToSelect;

  if (defaultTab && fullTabList.includes(defaultTab)) {
    // If a defaultTab is specified, use it as-is
    tabToSelect = defaultTab;
  } else if (value && fullTabList.includes(_constants.UploadCareTabTypes.PREVIEW)) {
    // If an existing file value is specified, go directly to the preview tab
    tabToSelect = _constants.UploadCareTabTypes.PREVIEW;
  } else {
    // Otherwise, just select the first tab
    var _fullTabList = _slicedToArray(fullTabList, 1);

    tabToSelect = _fullTabList[0];
  } // Open the actual modal


  var _uploadcare$openDialo = _uploadcareWidget.default.openDialog(null, tabToSelect, settings),
      dialogElement = _uploadcare$openDialo.dialogElement,
      fileColl = _uploadcare$openDialo.fileColl,
      always = _uploadcare$openDialo.always,
      addFiles = _uploadcare$openDialo.addFiles,
      switchTab = _uploadcare$openDialo.switchTab,
      done = _uploadcare$openDialo.done; // Add a unique ID for targeting/styling if it's provided


  if (styleId) {
    dialogElement.attr('id', styleId);
  } // Add some additional styling hooks based on props


  if (editImageDisabled) {
    dialogElement.addClass(EDIT_IMAGE_DISABLED_CLASS);
  } else {
    dialogElement.removeClass(EDIT_IMAGE_DISABLED_CLASS);
  }

  if (removeImageDisabled) {
    dialogElement.addClass(REMOVE_IMAGE_DISABLED_CLASS);
  } else {
    dialogElement.removeClass(REMOVE_IMAGE_DISABLED_CLASS);
  }

  if (submitAfterUpload) {
    dialogElement.addClass(SUBMIT_AFTER_UPLOAD_CLASS);
  } else {
    dialogElement.removeClass(SUBMIT_AFTER_UPLOAD_CLASS);
  } // Listen to file changes. Handles logic based on files + state


  handleWidgetState(dialogElement, fileColl, maxFileCount, dynamicPreviewTitle, submitAfterUpload, submitAfterUploadNotifyError); // Stop mousedown events from propagating outside of the dialog

  dialogElement.bind('mousedown', function (e) {
    e.stopPropagation();
  }); // Sometimes, we want to make sure clients don't accidentally close the widget.

  if (!closeViaOverlay) {
    dialogElement.off('dblclick');
  } // Track file errors and successful uploads


  startAnalytics(fileColl); // When the dialog is closed and valid files are selected, invoke the callback

  done(isMultiple ? handleFileGroupSelect : handleFileSelect); // When the dialog is closed, make sure the analytics are stopped

  always(function () {
    stopAnalytics();
  }); // Edit an image
  // Takes the provided URL and sends the image to Uploadcare. Then it takes the file info and associated it with the Uploadcare modal

  if (editImageUrl) {
    var client = new _uploadClient.UploadClient({
      publicKey: _constants.PUBLIC_KEY
    });
    client.uploadFile(editImageUrl).then(function (file) {
      addFiles([_uploadcareWidget.default.fileFrom('uploaded', file.uuid, settings)]);
      dialogElement.addClass(ONLY_EDIT_IMAGE_CLASS);
    }).catch(function (error) {
      // eslint-disable-next-line no-console
      console.error('openUploadcareModal editImageUrl error:', error);
      dialogElement.removeClass(ONLY_EDIT_IMAGE_CLASS);
    });
  } // NOTE: this block ONLY works for Uploadcare files and URLs that point to the Uploadcare CDN
  // If any existing files were provided, we need to add them to the dialog AFTER it's open.
  // This is because using uploadcare.filesFrom BEFORE the dialog creates a fileColl means that
  // fileColl.onAdd is never triggered, which breaks our progress / error detection in handleWidgetState.


  if (value) {
    var files;

    if (value instanceof FileList) {
      files = _uploadcareWidget.default.filesFrom('object', value, settings);
    } else {
      var urls = Array.isArray(value) ? value : [value]; // If value isn't already an array, create one

      var validUrls = urls.filter(function (url) {
        return !!url;
      });
      var strippedUrls = validUrls.map(_url.stripUploadcareUrlPatches); // Makes sure that the input and output URLs are formatted the same.

      if (strippedUrls.length) {
        files = _uploadcareWidget.default.filesFrom('uploaded', strippedUrls, settings);
      }
    }

    if (files) {
      addFiles(files);
      switchTab('preview');
    }
  }
};

var _default = openUploadcareModal;
exports.default = _default;